// libs
import React, { memo } from 'react';
import { useHistory, useLocation } from 'react-router';

// components
import { SHEET_TRANSITION } from 'shared/components/OverlaySheet';
import Header from 'shared/components/OTPVerification/LoginNudge/component/Header';

// styles
import {
  OverlaySheet,
  PrimaryButton,
  SecondaryButton,
  SecondaryButtonContainer,
  Separator,
  ArrowIcon,
  Title,
  SubTitle,
} from './styles';

// constants
import { AUTH_URI } from 'shared/constants/uri';

const NAV_KEY = 'Login Nudge';
const TEXTS = {
  TITLE: 'Login to access your wishlist',
  SIGN_UP: 'If you are new to Nykaa Fashion',
  LOG_IN: 'If you are already registered with us, continue login using:',
  SIGN_UP_BTN: 'Signup using mobile number',
  EMAIL: 'Email id',
  MOBILE: 'Mobile number',
};

interface ILoginNudge {
  title?: string;
  onNudgeHide: VoidFunction;
  redirectTo?: string;
}

function LoginNudge({ title = TEXTS.TITLE, onNudgeHide, redirectTo }: ILoginNudge) {
  const { search } = useLocation();
  const history = useHistory();
  const redirectToAuth = (event: React.MouseEvent, url: string) => {
    event.preventDefault();
    const params = new URLSearchParams();

    const pathname = redirectTo ? redirectTo : window.location.pathname + search;

    params.set('redirectURL', pathname.replace('?', '@'));

    history.push(AUTH_URI.PATH + url + '&' + params.toString());
  };

  return (
    <OverlaySheet
      onHide={onNudgeHide}
      navKey={NAV_KEY}
      transitionFrom={SHEET_TRANSITION.BOTTOM}
      data-test="login-nudge"
    >
      <Header />

      <Title>{title}</Title>
      <SubTitle>{TEXTS.SIGN_UP}</SubTitle>

      <PrimaryButton onClick={(e) => redirectToAuth(e, AUTH_URI.SIGN_UP)}>
        {TEXTS.SIGN_UP_BTN}
        <ArrowIcon className="icon-back" />
      </PrimaryButton>

      <Separator>
        <p className="seperate">or</p>
      </Separator>

      <div className="subtitle">{TEXTS.LOG_IN}</div>
      <SecondaryButtonContainer>
        <SecondaryButton onClick={(e) => redirectToAuth(e, AUTH_URI.LOGIN_VIA_EMAIL)}>
          {TEXTS.EMAIL}
        </SecondaryButton>
        <SecondaryButton onClick={(e) => redirectToAuth(e, AUTH_URI.LOGIN_VIA_MOBILE)}>
          {TEXTS.MOBILE}
        </SecondaryButton>
      </SecondaryButtonContainer>
    </OverlaySheet>
  );
}

export default memo(LoginNudge);
